/*@flow*/
export default (): any | string => {
  const map = window.cityMap || window.districtMap;
  if (!map) return '';

  let valid = true;
  const str = map.getBounds().toBBoxString();

  // Verify that bbox is valid
  str.split(',').forEach(s => {
    const v = parseFloat(s);
    if (v > 180 || v < -180) {
      valid = false;
    }
  });

  return valid ? str : '';
};
